import { Stack } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import dayjs from 'dayjs'

import { useAdminFund } from '@repo/common/queries/admin/fund'

import { FundCompositionChart } from '@/components/FundCompositionChart'
import { FundSummary } from '@/components/FundSummary'
import { FundTransactionsTable } from '@/components/FundTransactionsTable'
import { NavApprovalsControl } from '@/components/NavApprovalsControl'
import { useDynamicTitle, withTitle } from '@/utils/withTitle'

export const Route = createFileRoute('/_app/fund/$id/')({
  component: FundPage,
  head: withTitle((params) => `Fund ${params.id!.toUpperCase()}`),
})

function FundPage() {
  const { id } = Route.useParams()
  const today = dayjs().tz('America/New_York').format('YYYY-MM-DD')
  const fund = useAdminFund(id!)

  useDynamicTitle(fund.data?.name)

  return (
    <Stack>
      <FundSummary fund={fund.data} />

      <NavApprovalsControl fundId={id} />

      <FundCompositionChart fundId={id!} date={today} />

      <FundTransactionsTable fundId={id!} limit={200} maxHeight={400} />
    </Stack>
  )
}
